module.exports = __webpack_public_path__ + "img/sample-salad.1201053e.jpg";